import React from 'react';

import { BENEFITS } from './constants';

import './ContactLensStoreBenefit.scss';

export const ContactLensStoreBenefit = props => {
  const { baseImageUrl } = props;

  return (
    <div className="contact-lens-store-benefit">
      <div className="contact-lens-store-benefit__container">
        <h3 className="contact-lens-store-benefit__title">Store Benefit</h3>

        <ul className="contact-lens-store-benefit__list">
          {BENEFITS.map(({ key, icon, text }) => (
            <li key={key} className="contact-lens-store-benefit__item" data-key={key}>
              <img alt={key} src={`${baseImageUrl}/icons${icon}`} />
              <p className="contact-lens-store-benefit__item__text">{text}</p>
            </li>
          ))}
        </ul>

        <div className="contact-lens-store-benefit__find-store">
          <h4 className="contact-lens-store-benefit__find-store__title">Find Nearby Stores</h4>

          <ul className="contact-lens-store-benefit__find-store__tags">
            <li>Free eye test</li>
            <li>Lifetime service</li>
          </ul>

          <a className="contact-lens-store-benefit__find-store__button" href="/stores/sg">
            <span>STORE LOCATIONS</span>
          </a>
        </div>
      </div>
    </div>
  );
};
